/** 取权限树首个可访问菜单 path（与 permission 守卫一致） */
export function checkFinalMenuPath(menu) {
  if (menu.children && menu.children.length) {
    return checkFinalMenuPath(menu.children[0])
  }
  return menu.path
}

/**
 * 登录后 / 根路径应跳转的首页
 * - 有收银权限时优先进 /cashier 或 /newCashier（POS 默认工作台）
 * - 否则按后台菜单顺序取第一个
 * @param {import('vuex').Store} store
 * @returns {string | null} 权限未加载时返回 null
 */
export function resolveAppHomePath(store) {
  const menus = store.getters['user/permissions']?.[0]?.children || []
  if (!menus.length) return null

  // 有收银菜单时，/ 应进收银工作台，而非后台排序第一的业务菜单（如商品）
  if (hasMenuPath(store, '/cashier') || hasMenuPath(store, '/newCashier')) {
    return resolveCashierEntryPath(store)
  }

  const firstPath = menus[0].path
  if (firstPath === '/globalFiledPermission') {
    if (menus.length > 1) return checkFinalMenuPath(menus[1])
    return '/404'
  }
  return checkFinalMenuPath(menus[0])
}

export function hasMenuPath(store, path) {
  const menus = store.getters['user/permissions']?.[0]?.children || []
  return menus.some((menu) => menu.path === path)
}

/** 无 /cashier 权限时，纠正误进的旧收银路径；与 mixin getCashierHomePath 一致 */
export function resolveCashierEntryPath(store) {
  if (hasMenuPath(store, '/newCashier')) return '/newCashier'
  if (hasMenuPath(store, '/cashier')) return '/cashier'
  return resolveAppHomePath(store)
}
